"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Irb = void 0;
class Irb {
    constructor(idObject) {
        const { studyId } = idObject;
        this.id = `study.${studyId}`;
        this.idObject = idObject;
    }
    getId() {
        return this.id;
    }
    getIdObject() {
        return this.idObject;
    }
    getMetadata() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cachedEntry) {
                this.cachedEntry = yield this.getDatabaseEntry();
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _a = this.cachedEntry || {}, { packages } = _a, rest = __rest(_a, ["packages"]);
            return Object.assign({}, rest);
        });
    }
    setMetadata(data) {
        return __awaiter(this, void 0, void 0, function* () {
            delete this.cachedEntry;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { packages } = data, rest = __rest(data, ["packages"]);
            yield this.updateDatabaseEntry(rest);
        });
    }
    getPackage({ buildVersion, locale, modality }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cachedEntry) {
                this.cachedEntry = yield this.getDatabaseEntry();
            }
            return (_b = (_a = this.cachedEntry) === null || _a === void 0 ? void 0 : _a.packages) === null || _b === void 0 ? void 0 : _b[`${buildVersion}-${locale}-${modality}`];
        });
    }
    clearPackage({ buildVersion, locale, modality }) {
        return __awaiter(this, void 0, void 0, function* () {
            delete this.cachedEntry;
            const packageKey = `${buildVersion}-${locale}-${modality}`;
            yield this.updateDatabaseEntry({
                packages: {
                    [packageKey]: null,
                },
            });
        });
    }
    setPackage({ buildVersion, locale, modality }, arg2) {
        return __awaiter(this, void 0, void 0, function* () {
            const packageKey = `${buildVersion}-${locale}-${modality}`;
            delete this.cachedEntry;
            yield this.updateDatabaseEntry({
                packages: {
                    [packageKey]: Object.assign(Object.assign({ buildVersion,
                        locale,
                        modality }, arg2), { created_at: new Date() }),
                },
            });
        });
    }
    getDatabaseEntry() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('getDatabaseEntry not implemented');
        });
    }
    setDatabaseEntry(entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`setDatabaseEntry not implemented, ${entry}`);
        });
    }
    updateDatabaseEntry(entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`updateDatabaseEntry not implemented, ${entry}`);
        });
    }
}
exports.Irb = Irb;
//# sourceMappingURL=irb.js.map